import React from 'react'
import Back from '../common/Back'
import FeaturesCard from './FeaturesCard'

const Features = () => {
    return (
        <>
            <Back title='Features'/>
            <FeaturesCard />
        </>
    )
}

export default Features
